import { Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  buildSessionsSousMenuItem,
  formationsCatalogueSousMenuItem,
  inscriptionsSousMenuItem,
  planningFormateursSousMenuItem,
  planningRessourcesSousMenuItem
} from './sous-menu-items.constantes';

export function buildFormationMenu(injector: Injector): Observable<MenuItemAggregate> {
  return buildSessionsSousMenuItem(injector).pipe(
    map((sessionsSousMenuItem) => {
      return new MenuItemAggregate('icon-trello', 'Formation', [
        formationsCatalogueSousMenuItem,
        sessionsSousMenuItem,
        inscriptionsSousMenuItem,
        planningFormateursSousMenuItem,
        planningRessourcesSousMenuItem,
      ]);
    })
  );
}
